interface SkillBadgeProps {
  skill: string
}

export function SkillBadge({ skill }: SkillBadgeProps) {
  return <span className="bg-slate-100 text-slate-700 text-sm font-medium px-3 py-1 rounded-full">{skill}</span>
}
